import React, { Component } from 'react';

import classnames from 'classnames';
import { WithStyles, withStyles } from '@mui/styles';

import APLogoStyle from "./styles/APLogo.style";

interface APLogoProps extends WithStyles<typeof APLogoStyle> {
  className?: string,
  open: boolean
}

class APLogo extends Component<APLogoProps, {}> {
  render() {
    const {
      classes,
      open,
      ...otherProps
    } = this.props;

    const logoCls = classnames(classes.affiliateLogo, {
      [classes.minified]: !open
    });

    return <div className={logoCls} {...otherProps} data-testid='AP-Logo' />;
  }
}

export default withStyles(APLogoStyle)(APLogo);
